import MainLayout from "layouts/Main";
import { settingsTabs } from "views/Dashboard/Settings/tabs";

import BatteryGroupsTable from "./BatteryGroupsTable";

const BatteryGroups = () => {
  return (
    <MainLayout tabs={settingsTabs}>
      <BatteryGroupsTable />
    </MainLayout>
  );
};

export default BatteryGroups;
